import React from 'react';
import { object, string } from 'prop-types';
// import { Alert } from 'reactstrap';

// https://react-hook-form.com/advanced-usage#ErrorMessage
const ErrorMessage = ({ errors, name }) => {
  // Bottom page error message
  if (!name && Object.keys(errors).length > 0) {
    return (
      <p className="text-danger">
        Une valeur saisie est erronée ou manquante. Contrôlez le formulaire puis validez à nouveau.
      </p>
    );
  }

  const msg = errors?.[name]?.message || '';

  if (name === 'general' && Object.keys(errors).length > 0) {
    // return msg && <Alert color="danger">{msg}</Alert>;
    return (
      msg && (
        <div className="alert alert-danger show" role="alert">
          {msg}
        </div>
      )
    );
  }

  return (msg && <p className="text-danger">{msg}</p>) ?? null;
};

ErrorMessage.propTypes = {
  errors: object.isRequired,
  name: string,
};

ErrorMessage.defaultProps = { name: undefined };

export default ErrorMessage;
